import { IconProps } from '../ui/Icon/types';
import Icon from '../ui/Icon';

export default function IconArrowLeft(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
        fill="currentColor"
      />
    </Icon>
  );
}
